module.exports = __webpack_public_path__ + "static/scale-model-of-soldiers-and-sailors-monument-in-indianapolis-indiana-f206648054e94cd17b64df2f75c39888.png";